import { cn } from '../lib/cn';

const SIZES = { sm: 'h-3.5 w-3.5 border-[1.5px]', md: 'h-5 w-5 border-2', lg: 'h-8 w-8 border-2' };

export function Spinner({ size = 'md', className }: { size?: keyof typeof SIZES; className?: string }) {
  return (
    <span
      role="status"
      aria-label="Loading"
      className={cn('inline-block animate-spin rounded-full border-current border-r-transparent text-muted', SIZES[size], className)}
    />
  );
}

/** Centered spinner for a loading section. */
export function Loading({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="flex items-center justify-center gap-2 py-12 text-sm text-muted">
      <Spinner />
      {label}
    </div>
  );
}
